@if (position) {
  @if (showCheckboxes) {
    <td class="relative px-7 sm:w-12 sm:px-6">
      <input
        type="checkbox"
        [disabled]="isDisabled || (position.quantity | stringToNumber) === 0"
        [(ngModel)]="isChecked"
        (change)="positionSelected.emit(isChecked)"
        class="absolute left-4 top-1/2 -mt-2 h-4 w-4 rounded border-edge-strong text-indigo-600 focus:ring-indigo-600 disabled:border-edge disabled:bg-surface-disabled"
      />
    </td>
  }
  <td
    class="whitespace-nowrap py-4 pr-3 text-sm font-medium text-fg-primary"
    [class.!text-fg-muted]="(position.quantity | stringToNumber) === 0"
    [class.pl-3]="!showCheckboxes"
  >
    {{ position.displayName }}
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right">
    {{ position.quantity | stringToNumber }}
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-left">Stunden</td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right tabular-nums">
    {{ position.unitPrice | formatAmount }}
  </td>
  <td class="whitespace-nowrap px-3 py-4 text-sm text-fg-secondary text-right">
    {{ position.vatRate | formatPercent }}%
  </td>
  <td
    class="whitespace-nowrap px-3 py-4 text-sm font-medium text-fg-secondary text-right tabular-nums"
  >
    {{ position.totalPrice | formatAmount }}
  </td>
  @if (!showCheckboxes) {
    <td class="whitespace-nowrap px-3 py-4">
      <div class="flex items-center justify-end">
        <button
          [disabled]="isDisabled"
          class="flex items-center text-fg-faint hover:text-fg-subtle disabled:hover:text-fg-faint"
          (click)="deletePosition.emit(position)"
        >
          <app-ng-icon name="heroTrash"></app-ng-icon>
        </button>
      </div>
    </td>
  }
}
